// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px 0;
}
.dialog-header h2[mat-dialog-title] {
  margin: 0;
  font-size: 20px;
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
}

.close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #e3e3e3;
  padding: 4px;
  display: flex;
  align-items: center;
}
.close-btn:hover {
  color: #0b2d71;
}

mat-dialog-content {
  padding: 16px 24px;
  overflow-y: auto;
  max-height: calc(70vh - 120px);
}

.dialog-body {
  color: #0b2d71;
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
}

.dialog-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 8px 24px 16px;
}

.btn-cancel,
.btn-reset {
  border: 1px solid #0066b2;
  background: white;
  color: #0066b2;
  padding: 6px 14px;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  cursor: pointer;
  white-space: nowrap;
}
.btn-cancel:hover,
.btn-reset:hover {
  background-color: rgb(167.8, 217.7685393258, 255);
}

.btn-restore {
  border: none;
  background-color: #0066b2;
  color: white;
  padding: 6px 14px;
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  cursor: pointer;
  white-space: nowrap;
}
.btn-restore:hover {
  background-color: #0b2d71;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
